var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-payment"},[(_vm.transactionResult)?_c('div',{staticClass:"submit-payment__wrap"},[_c('div',{staticClass:"order-right__button_liqpay",domProps:{"innerHTML":_vm._s(_vm.transactionResult)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }